import { render, staticRenderFns } from "./CoproffBlocStat.vue?vue&type=template&id=0cbb550e&scoped=true"
import script from "./CoproffBlocStat.vue?vue&type=script&lang=js"
export * from "./CoproffBlocStat.vue?vue&type=script&lang=js"
import style0 from "./CoproffBlocStat.vue?vue&type=style&index=0&id=0cbb550e&prod&lang=css"
import style1 from "./CoproffBlocStat.vue?vue&type=style&index=1&id=0cbb550e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb550e",
  null
  
)

export default component.exports